var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":"","fill-height":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{attrs:{"size":50,"indeterminate":true,"color":"resBlue"}})],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }